// extracted by mini-css-extract-plugin
export default {"sobre":"styles_sobre__SIW1S","row":"styles_row__NiYH7","textCol":"styles_textCol__c7Qt4","highlight":"styles_highlight__raWq4","mediaCol":"styles_mediaCol__bBHyN"};